import { useRef, useState, useCallback } from "react";

// A2: одноразовые действия — повторные клики во время запроса игнорируются (ref срабатывает синхронно, в отличие от state)
export const useSingleFlight = () => {
  const inFlight = useRef(new Set());
  const [busyKeys, setBusyKeys] = useState([]);
  const run = useCallback(async (key, fn) => {
    if (inFlight.current.has(key)) return undefined;
    inFlight.current.add(key);
    setBusyKeys((k) => [...k, key]);
    try {
      return await fn();
    } finally {
      inFlight.current.delete(key);
      setBusyKeys((k) => k.filter((x) => x !== key));
    }
  }, []);
  const isBusy = useCallback((key) => busyKeys.includes(key), [busyKeys]);
  return { run, isBusy };
};
